module.exports = __webpack_public_path__ + "img/zoom.4cab3773.svg";